// extracted by mini-css-extract-plugin
export default {"button":"_666i6wxaVJfRnVIlcOe-uQ==","loader":"ItliLGuMWuAXC1c3sGpvnQ==","opacity":"KawF-7iAONQklxmepCKT3w=="};